import { ReactNode, FC } from 'react';
import styled, { css } from 'styled-components';

interface LoadingPageProps {
  hidden?: boolean;
  title?: string;
}

const LoadingPage = ({
  hidden,
  title,
}: LoadingPageProps): JSX.Element | null => {
  if (hidden) return null;

  return (
    <Container hidden={hidden}>
      <Title>{title}</Title>
      <Dots />
    </Container>
  );
};

LoadingPage.defaultProps = {
  hidden: true,
  title: 'Processing...',
};

/** ------------------------------------------------------------------
 * Style
 ------------------------------------------------------------------ */

export default LoadingPage;

const Container = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgb(0 0 0 / 17%);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
`;

const Title = styled.h3`
  user-select: none;
`;

const Dots = styled.div`
  width: 12px;
  aspect-ratio: 1;
  border-radius: 50%;
  animation: d5 1s infinite linear alternate;

  @keyframes d5 {
    0% {
      box-shadow:
        20px 0 #000,
        -20px 0 #0002;
      background: #000;
    }
    33% {
      box-shadow:
        20px 0 #000,
        -20px 0 #0002;
      background: #0002;
    }
    66% {
      box-shadow:
        20px 0 #0002,
        -20px 0 #000;
      background: #0002;
    }
    100% {
      box-shadow:
        20px 0 #0002,
        -20px 0 #000;
      background: #000;
    }
  }
`;
